<!-- 表单的筛选 -->
<template>
    <div>
        <el-button
            type="success"
            size="mini"
            plain
            icon="el-icon-refresh-left"
            @click="DoStart"
            class="column__tool__buttom"
        >恢复&nbsp;</el-button>
    </div>    
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { startApi } from '@/api/core/table/table';

export default {
  name: "StartTableBtn",
  
  mixins: [BaseVue],
  
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true
    }
  },
  
  data() {
    return {
      tagclass: "info",
      tagtext: ""
    };
  },
  
  methods: {
    init() {
      // 初始化逻辑
    },
    
    DoStart() {
      this.$confirm(`确定要恢复"${this.title}"吗？`, "恢复确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "放弃"
      }).then(() => {
        startApi(this.serverUrl, this.id)
          .then(() => {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.$emit("onSuccess");
          })
          .catch(error => {
            console.log(error);
            this.$message.error("恢复失败");
          });
      })
    }
  },
  
  mounted() {
    this.init();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
